export default __webpack_public_path__ + "static/media/aikit_wrapper.2297c097.svg";